import { render } from "./SharedDataKeyEdit.vue?vue&type=template&id=a04f3ba4"
import script from "./SharedDataKeyEdit.vue?vue&type=script&lang=js"
export * from "./SharedDataKeyEdit.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__